module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/i18n-279.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/i18n.md
// module id = 724
// module chunks = 434